// The info-view bars chart persists no report params of its own; the set is empty by design.

import { buildClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = []

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  buildClearParams({ questionKey, answerVariants, batches, clusters, question: QUESTION_PARAMS })
